import { render, staticRenderFns } from "./ProductGroupEdit.vue?vue&type=template&id=324619d8&scoped=true&"
import script from "./ProductGroupEdit.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324619d8",
  null
  
)

export default component.exports